import React from 'react';
import { Menu } from 'components/atoms/dropdown';
import {
  EstimateFieldFilter,
  EstimateFieldFilterOperationType,
  EstimateRelativeDirection,
} from '../../filters/estimate';
import { renderRelativeMenuItem } from './relative-menu-item';

export const renderOverlay = (
  filter: EstimateFieldFilter,
  onChange: (filter: EstimateFieldFilter) => void,
) => (
  <Menu
    className="date-criteria"
    selectable
    selectedKeys={[filter.type.toString()]}
    onSelect={({ key }) => {
      const type = key as EstimateFieldFilterOperationType;

      onChange({
        ...filter,
        type,
        days: (filter as EstimateFieldFilter).days,
        direction:
          (filter as EstimateFieldFilter).direction ??
          EstimateRelativeDirection.Early,
      } as EstimateFieldFilter);
    }}
  >
    {renderRelativeMenuItem(
      filter,
      EstimateFieldFilterOperationType.IsMoreThan,
      onChange,
    )}
    {renderRelativeMenuItem(
      filter,
      EstimateFieldFilterOperationType.IsLessThan,
      onChange,
    )}
  </Menu>
);
